import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

const UI = {
  en: {
    nav_services: "Services",
    nav_coverage: "Coverage",
    nav_about: "About",
    nav_book: "Book Now",
    nav_contact: "Contact",
    nav_reviews: "Reviews",
    nav_drive: "Drive With Us",
    hiring: "Now hiring drivers — a great business opportunity in all 50 states. Join MY TAXI today!",
    drive_kicker: "Now hiring",
    drive_title: "Drive With Us",
    drive_desc: "Own your schedule and earn across all 50 states. Airport runs, deliveries and long-distance trips — a real business opportunity with MY TAXI. Leave your details and we'll reach out.",
    df_name: "Full name",
    df_phone: "Phone number",
    df_email: "Email",
    df_city: "City",
    df_state: "State",
    df_experience: "Years of driving experience",
    df_car: "Do you have your own vehicle?",
    df_yes: "Yes",
    df_no: "No",
    df_notes: "Tell us about yourself (optional)",
    df_submit: "Apply to Drive",
    df_sending: "Sending...",
    df_success: "Application received! We'll contact you soon.",
    df_error: "Something went wrong. Please call us directly.",
    reviews_kicker: "What riders say",
    reviews_title: "Reviews",
    hero_book: "Book a Ride",
    hero_call: "Call Now",
    scroll: "Scroll",
    services_kicker: "What we do",
    services_title: "Services",
    coverage_kicker: "Where we go",
    about_kicker: "Our story",
    book_kicker: "Reserve",
    book_title: "Book Your Ride",
    book_desc: "Fill in the details and we'll confirm by phone or WhatsApp within minutes.",
    f_name: "Full name",
    f_phone: "Phone number",
    f_service: "Service",
    f_pickup: "Pickup location",
    f_dropoff: "Drop-off location",
    f_date: "Date",
    f_time: "Time",
    f_pax: "Passengers",
    f_notes: "Notes (optional)",
    f_submit: "Request Booking",
    f_sending: "Sending...",
    f_success: "Booking received! We'll contact you shortly.",
    f_error: "Something went wrong. Please call us directly.",
    or_call: "Prefer to talk? Call or WhatsApp us anytime",
    contact_kicker: "Get in touch",
    contact_title: "Ready when you are",
    whatsapp: "WhatsApp",
    email: "Email",
    phone: "Phone",
    rights: "All rights reserved.",
    admin: "Admin",
    chapters: [
      { n: "01", t: "Anywhere in America", d: "From a quick Long Island hop to a cross-country haul — one call gets you moving." },
      { n: "02", t: "Always on time", d: "Live flight tracking and precise pickups mean you never wait and never miss a flight." },
      { n: "03", t: "Elegant & safe", d: "Clean, comfortable vehicles and licensed, professional drivers on every single trip." },
    ],
  },
  es: {
    nav_services: "Servicios",
    nav_coverage: "Cobertura",
    nav_about: "Nosotros",
    nav_book: "Reservar",
    nav_contact: "Contacto",
    nav_reviews: "Reseñas",
    nav_drive: "Conduce",
    hiring: "Se buscan conductores — una gran oportunidad de negocio en todos los estados. ¡Únete a MY TAXI hoy!",
    drive_kicker: "Estamos contratando",
    drive_title: "Conduce Con Nosotros",
    drive_desc: "Maneja tu propio horario y gana en los 50 estados. Aeropuerto, entregas y viajes de larga distancia — una verdadera oportunidad de negocio con MY TAXI. Déjanos tus datos y te contactamos.",
    df_name: "Nombre completo",
    df_phone: "Teléfono",
    df_email: "Correo",
    df_city: "Ciudad",
    df_state: "Estado",
    df_experience: "Años de experiencia manejando",
    df_car: "¿Tienes tu propio vehículo?",
    df_yes: "Sí",
    df_no: "No",
    df_notes: "Cuéntanos sobre ti (opcional)",
    df_submit: "Postularme para Conducir",
    df_sending: "Enviando...",
    df_success: "¡Postulación recibida! Te contactaremos pronto.",
    df_error: "Algo salió mal. Por favor llámanos directamente.",
    reviews_kicker: "Lo que dicen",
    reviews_title: "Reseñas",
    hero_book: "Reservar Viaje",
    hero_call: "Llamar",
    scroll: "Desliza",
    services_kicker: "Lo que hacemos",
    services_title: "Servicios",
    coverage_kicker: "A dónde vamos",
    about_kicker: "Nuestra historia",
    book_kicker: "Reserva",
    book_title: "Reserva tu Viaje",
    book_desc: "Completa los datos y confirmaremos por teléfono o WhatsApp en minutos.",
    f_name: "Nombre completo",
    f_phone: "Teléfono",
    f_service: "Servicio",
    f_pickup: "Lugar de recogida",
    f_dropoff: "Destino",
    f_date: "Fecha",
    f_time: "Hora",
    f_pax: "Pasajeros",
    f_notes: "Notas (opcional)",
    f_submit: "Solicitar Reserva",
    f_sending: "Enviando...",
    f_success: "¡Reserva recibida! Te contactaremos pronto.",
    f_error: "Algo salió mal. Por favor llámanos directamente.",
    or_call: "¿Prefieres hablar? Llámanos o escríbenos por WhatsApp",
    contact_kicker: "Contáctanos",
    contact_title: "Listos cuando tú lo estés",
    whatsapp: "WhatsApp",
    email: "Correo",
    phone: "Teléfono",
    rights: "Todos los derechos reservados.",
    admin: "Admin",
    chapters: [
      { n: "01", t: "A cualquier lugar", d: "Desde un viaje rápido en Long Island hasta un traslado de costa a costa — una llamada y estás en marcha." },
      { n: "02", t: "Siempre a tiempo", d: "Seguimiento de vuelos en vivo y recogidas precisas: nunca esperas ni pierdes un vuelo." },
      { n: "03", t: "Elegante y seguro", d: "Vehículos limpios y cómodos con conductores profesionales con licencia en cada viaje." },
    ],
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("mytaxi_lang") || "en");
  const toggle = () => {
    const next = lang === "en" ? "es" : "en";
    setLang(next);
    localStorage.setItem("mytaxi_lang", next);
  };
  const t = (key) => UI[lang][key];
  const pick = (obj, key) => (obj ? obj[`${key}_${lang}`] : "");
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
